import Contribution from "./Contribution";
import ContributionHistory from "./ContributionHistory";
import QuickView from "./QuickView";
import PersonalChecksPaymentModal from "./PersonalChecksPaymentModal";
import WireTransferPaymentModal from "./WireTransferPaymentModal";
export {
    Contribution,
    ContributionHistory,
    QuickView,
    PersonalChecksPaymentModal,
    WireTransferPaymentModal
}


export enum ClientSplitAmountType {
    Premium = "Premium",
    Trust = "Trust",
    Merchant = "Merchant",
    Refund = "Refund",
}

type SplitAmountResult = {
    amountLessMerchant: number;
    merchantAmount: number;
    premiumAmount: number;
    totalAmount: number;
    trustAmount: number;
}

type ClientSplitAmount = { amount: number; type: ClientSplitAmountType ; }

/**
 * Sum Payment Amounts and returns as SplitAmountResult
 * @param amounts
 */
export const sumClientSplitAmount: (amounts: ClientSplitAmount[]) => SplitAmountResult = (amounts: ClientSplitAmount[]) => {
    const result: SplitAmountResult = {
        amountLessMerchant: 0,
        merchantAmount: 0,
        premiumAmount: 0,
        totalAmount: 0,
        trustAmount: 0
    };

    amounts.forEach(amt => {
        result.totalAmount += amt.amount;

        switch (amt.type) {
            case ClientSplitAmountType.Merchant:
                result.merchantAmount += amt.amount;
                break;
            case ClientSplitAmountType.Trust:
                result.trustAmount += amt.amount;
                break;
            case ClientSplitAmountType.Premium:
                result.premiumAmount += amt.amount;
                break;
        }
    });

    result.amountLessMerchant = result.totalAmount - result.merchantAmount;

    console.info(result)
    return result;
};